import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  decimalStyle: {
    fontSize: 16,
  },
  marketValueText: {
    color: 'white',
    letterSpacing: 0.29,
  },
});
